import { render } from "./userEfficiency.html?vue&type=template&id=5aaa1dc0&scoped=true&ts=true"
import script from "./userEfficiency.ts?vue&type=script&lang=ts"
export * from "./userEfficiency.ts?vue&type=script&lang=ts"

import "./userEfficiency.scss?vue&type=style&index=0&id=5aaa1dc0&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aaa1dc0"]])

export default __exports__